import { createContext, useContext } from "react";

export type ISrmAuthenticationContext = ISrmUserNotAuthenticatedContext | ISrmUserAuthenticatedContext;

export interface ISrmUserNotAuthenticatedContext {
    isInitialized: boolean;
    isAuthenticated: false;
    login: () => void;
}

export interface ISrmUserAuthenticatedContext {
    isInitialized: true;
    isAuthenticated: true;
    userName: string;
    dropApiToken: string;
    getTokenFn: () => string;
    logout: () => Promise<void>;
}

export const defaultSrmAuthenticationContext: ISrmAuthenticationContext = {
    isInitialized: false,
    isAuthenticated: false,
    login: () => ({}),
};

export const SrmAuthenticationContext = createContext<ISrmAuthenticationContext>(defaultSrmAuthenticationContext);

export const useSrmAuthenticationContext = () => useContext(SrmAuthenticationContext);
export const useSrmAuthenticatedContext = () => {
    const context = useContext(SrmAuthenticationContext);

    if (!context.isInitialized) {
        throw new Error("Authentication context is not initialized.");
    }

    return context as ISrmUserAuthenticatedContext;
};
